import { Component, OnInit, NgZone, ViewChild, OnDestroy, ChangeDetectorRef, AfterViewChecked } from "@angular/core";
import { filter, take, takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";

import { NavigationEnd, Router, Scroll } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ConfirmRemarksComponent } from "../patient-appointment/confirm-remarks/confirm-remarks.component";
import { AppointmentRemarksDialogComponent } from "./appointment-remarks-dialog/appointment-remarks-dialog.component";
import { AppointmentReasonreamrksDialogComponent } from "./appointment-reasonreamrks-dialog/appointment-reasonreamrks-dialog.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatSidenav } from "@angular/material/sidenav";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { IencounterSearch } from "../../interface/IencounterSearch";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { AppointmentService } from "../../services/Sappointment.service";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { OPD_REPORT_NAME, OPD_REPORT_TYPE } from "../../properties/opd-report-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { ReportService } from "projects/lib/medcare-core-lib/src/lib/services/report.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { Configuration } from "projects/lib/medcare-core-lib/src/lib/shared/Configuration";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { AddWaitingListDialogComponent } from "../../shared/add-waiting-list-dialog/add-waiting-list-dialog.component";
import moment from "moment";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { SearchHeaderService } from "../../services/SsearchHeader.service";
import { AppoinmentPatientHistoryDialogComponentComponent } from "./appointment-patient-history/appoinment-patient-history-dialog-component/appoinment-patient-history-dialog-component.component";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { MasterKeys } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";

@Component({
  selector: "app-patient-appointment-list",
  templateUrl: "./patient-appointment-list.component.html",
  styleUrls: ["./patient-appointment-list.component.scss"],
  providers: [DatePipe],
})
export class PatientAppointmentListComponent implements OnInit, OnDestroy  {
  @ViewChild("drawerEncounter") drawerEncounter: MatSidenav;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  protected _onDestroy = new Subject<void>();
  //  selectedAppointmentsCount: number = 0;
  displayedColumns: any = OPD_CONST.appoinmenList;
  waitingListDisplayedColumns: string[] = OPD_CONST.waitingListColumns;
  waitingListDataSource = new MatTableDataSource<any>();
  dataSource = new MatTableDataSource<any>();
  search: IencounterSearch;
  private subscriptionList = new Subscription();
  totalDataLength: number = 0;
  pageSize: number = 0;
  paginatorOptions: any;
  pageIndex: number = 0;
  offsetData: number = 0;
  selectedEncounter: any;
  statusCounts: {
    booked: number;
    arrived: number;
    cancelled: number;
    rescheduled: number;
    noShow: number;
    paymentReceived: number;
  } = {
      booked: 0,
      arrived: 0,
      cancelled: 0,
      rescheduled: 0,
      noShow: 0,
      paymentReceived: 0
    };
  priorityCounts: {
    urgent: number;
    high: number;
    normal: number;
    low: number
  } = {
      urgent: 0,
      high: 0,
      normal: 0,
      low: 0
    };
  searchAppt: {
    fromDate: any;
    toDate: any;
    mrn: any;
    doctor: any;
    dept: any;
    consultationType: any;
    apptype: any;
    pname: any;
    status?:any;
    patientCategory?:any;
    calledStatus?:any;
    priority?:any;
  } = {
      fromDate: "",
      toDate: "",
      mrn: "",
      doctor: "",
      dept: "",
      consultationType: "",
      apptype: "",
      pname: "",
      status:"",
      patientCategory:"",
      calledStatus:"",
      priority:""
    };
  previousInternalRemarks: any[] = [];
  searchList: any[];
  public searchResult: any = {
    appointmentDate: {
      start: new Date(new Date().setHours(0, 0, 0, 0)),
      end: new Date(new Date().setHours(23, 59, 0, 0)),
    },
    doctor: "",
    mrnno: "",
  };
  public appointmentList: any = [];
  isResschedule: boolean = true;
  selectedRow: number = -1;
  statusList: any = {
    all: [],
    pending: [],
    booked: [],
    arrived: [],
    cancelled: [],
    noshow: [],
  };
  username: string;
  userId: string;
  usermasterid: string;
  userRightList: any = [];
  isPatientCanRescheRights: boolean = false;
  langaugeValue:string="";
  selectedTabIndex :number= 0;
  AppointmentCheckInTime:number=0;
  isNeedTranslator: boolean = true;
  orgCode: string;
  showPatientPrefix: boolean = false;
  constructor(
    private ngZone: NgZone,
    private httpService: AppBaseService,
    private searchService: SearchService,
    private patientService: PatientService,
    public datePipe: DatePipe,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    private langService: MultiLanguageService,
    private appoinmentService: AppointmentService,
    public generalApiService: GeneralUrlService,
    private reportService:ReportService,
    public authService: AuthService,
     private thConvertService:thEnConverterService,
     private applicationConfigService: ApplicationConfigService,
     public searchHead: SearchHeaderService,
  ) {}

  /**
   *Load method
   *
   * @memberof PatientAppointmentListComponent
   */
  ngOnInit() {
    // this.searchList = this.appoinmentService.getappointmentSearchList(this);
    this.getUnitData();
    this.getSearchFilter();
    this.pageSize = Configuration.PAGINATOR_DEFAULT;
    this.paginatorOptions = Configuration.PAGINATOR_OPTIONS;
    this.searchAppt.fromDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.searchAppt.toDate = new Date(new Date().setHours(23, 59, 0, 0));
    this.getAppointmentList();
    this.getstatusCount();
    this.langaugeValue=localStorage.getItem("lan");
    this.langService.changeFooterLaber().then((val) => {
      // this.paginator._intl.itemsPerPageLabel = val;
       if (this.paginator?._intl) {
        this.paginator._intl.itemsPerPageLabel = val;
       }
    });
    // this.searchService.setSearch(this.searchList);
    this.subscriptionList.add(
      this.searchService.getResult.subscribe((res) => {
        this.serachStructureURL(res);
      })
    );

    let quickSearch = this.searchService.getElasticSearch.subscribe(quickSearch => {
      let result = { MRN: quickSearch };
      this.serachStructureURL(result);
    });
    this.subscriptionList.add(quickSearch);
    this.getUserInfo();
    this.getAppointmentList();
    this.getstatusCount();
    

    this.langService.changeFooterLaber().then((val) => {
      if(this.paginator){
      this.paginator._intl.itemsPerPageLabel = val;
      }
    });
    this.getAppConfig()
  }
    public getAppConfig(): void {
      this.applicationConfigService
        .getModuleConfiguration(OPD_CONST.appConfigPatientManagement)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if(res) {
           let CheckInTime = res.find(i => i.key == OPD_CONST.appConfigAppointmentCheckInTime);
           this.AppointmentCheckInTime = CheckInTime.valueList ? CheckInTime.valueList[0].numberValue: 0
          }
        });
    }
    getUnitData(){
      this.authService.getUnit().then((value: any) => {
      this.orgCode = value.orgCode;
      this.getOrgAppConfigList();
    })
    }
   getOrgAppConfigList() {
         let appConfig: any;
         this.httpService.setResourceURL(MICROSERVICES.OPD_SERVICE);
         this.httpService
           .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
           .pipe(takeUntil(this._onDestroy))
           .subscribe((res) => {
             if (res) {
               appConfig = res.keys;
               appConfig.forEach((element) => {
                 if (element.key == MasterKeys.IS_NEED_TRANSLATOR) {
                   if (element.valueList.length > 0) {
                     this.isNeedTranslator = (element.valueList[0].code == "true") ? true : false;
                   }
                   if (!this.isNeedTranslator) {
                     this.displayedColumns = this.displayedColumns.filter(
                       column => column !== "needTranslator"
                     );
                   }
                 }
                 if (element.key == MasterKeys.SHOW_PATIENT_PREFIX) {
                   if (element.valueList.length > 0) {
                     this.showPatientPrefix = (element.valueList[0].code == "true") ? true : false;
                   }
                  }
               });
             }
           });
   
       }
  /**
   *set search ist
   *
   * @param {*} res
   * @memberof PatientAppointmentListComponent
   */
   serachStructureURL(res) {
    this.searchAppt.fromDate = res.daterange && res.daterange.startDate
      ? new Date(new Date(res.daterange.startDate.$d).setHours(0, 0, 0, 0))
      : "";
    if (res.daterange && res.daterange.endDate) {
      this.searchAppt.toDate = new Date(new Date(res.daterange.endDate.$d).setHours(23, 59, 59, 999));
      var today = this.epochConverter(this.searchAppt.fromDate);
      var sameDay = this.epochConverter(this.searchAppt.toDate);
      if (today == sameDay)
        this.searchAppt.toDate = new Date(
          res.daterange.endDate.$d.setHours(23, 59, 0, 0)
        );
    } else {
      this.searchAppt.toDate = null;
    }
    this.searchAppt.apptype = res.AppointmentType
      ? res.AppointmentType.code
      : "";
    this.searchAppt.consultationType = res.consultationType ? res.consultationType.code : "";  
    this.searchAppt.dept = res.Department ? res.Department.code : "";
    this.searchAppt.doctor = res.Doctor ? res.Doctor.code : "";
    this.searchAppt.mrn = res.MRN;
    this.searchAppt.status = res.Status ? res.Status.code : "";
    this.searchAppt.pname = res.PatientName? res.PatientName : "";
    this.searchAppt.patientCategory = res.patientCategory ? res.patientCategory.code : "";
    this.searchAppt.calledStatus = res.calledStatus ? res.calledStatus.desc : "";
    this.searchAppt.priority = res.priority ? res.priority.code : "";
    if(this.selectedTabIndex==0){

      this.offsetData = 0;
      this.pageSize = 10;
      this.getAppointmentList();
      this.getstatusCount();
    }else{
      this.offsetData=0
      this.pageSize=10
      this.getWaitingList();
    }
   
  }
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.username = value.userName;
      this.userId = value.userId;
      this.usermasterid = value.user_code;
      this.userRightList = value.userSpecialRightList;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splCanRightPatient)
            this.isPatientCanRescheRights = true;
        });
      }
    });
  }
  /**
   *Getapi for status Count List
   *
   * @memberof PatientAppointmentListComponent
   */
  getstatusCount() {
    var fromDate = this.searchAppt.fromDate
      ? this.epochConverter(this.searchAppt.fromDate)
      : "";
    var toDate = this.searchAppt.toDate
      ? this.epochConverter(this.searchAppt.toDate)
      : "";
    var payload = this.appoinmentService.getstatusReqPayload(
      this,
      fromDate && this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(fromDate): fromDate,
      toDate && this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(toDate): toDate,
      true
    );
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(OPD_API_URL.OPD_SERVICE, payload)
        .subscribe((res) => {
          this.statusCounts = { booked: 0, arrived: 0, cancelled: 0, rescheduled: 0, noShow: 0, paymentReceived: 0 };
          this.priorityCounts = { urgent: 0, high: 0, normal: 0, low: 0 };
          if (res.length > 0) {
            res.forEach((eachStatus) => {
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.booked) {
                this.statusCounts.booked = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.arrived) {
                this.statusCounts.arrived = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.cancelled) {
                this.statusCounts.cancelled = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.rescheduled) {
                this.statusCounts.rescheduled = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.noShow) {
                this.statusCounts.noShow = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.paymentReceived) {
                this.statusCounts.paymentReceived = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.Urgent) {
                this.priorityCounts.urgent = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.Low) {
                this.priorityCounts.low = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.High) {
                this.priorityCounts.high = eachStatus.count;
              }
              if (eachStatus._id == OPD_CONST.apppointmentListDisplay.Normal) {
                this.priorityCounts.normal = eachStatus.count;
              }
            });
          }
        }));
  }

  /**
   *Get Appointment List Data
   *
   * @memberof PatientAppointmentListComponent
   */
  public getAppointmentList() {
    this.appointmentList = [];
    var fromDate = this.searchAppt.fromDate
      ? this.epochConverter(this.searchAppt.fromDate)
      : "";
    var toDate = this.searchAppt.toDate
      ? this.epochConverter(this.searchAppt.toDate)
      : "";
    var payload = this.appoinmentService.getstatusReqPayload(
      this,
      fromDate && this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(fromDate): fromDate,
      toDate && this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(toDate): toDate,
      false
    );
    this.httpService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.httpService.getResource(payload).subscribe((res) => {
        this.statusList = {
          all: [],
          pending: [],
          booked: [],
          arrived: [],
          cancelled: [],
          noshow: [],
        };
        if (res != null) {
          this.appointmentList = this.appoinmentService.getappoitmentList(
            res,
            this
          );
          this.appointmentList.forEach((element: any) => {
            if (Array.isArray(element.specialRequirements)) {
              const displayTexts = element.specialRequirements
                .map((req: any) => `• ${req.display.trim()}`)
                .filter(Boolean);
              element.specialRequirementTooltip = displayTexts.join('\n');
            } else {
              element.specialRequirementTooltip = '';
            }
          });
          this.dataSource = new MatTableDataSource<any>(this.appointmentList);
        }
      })
    );
  }

  /**
   *
   *
   * @param {*} encounterId
   * @param {*} type
   * @memberof PatientAppointmentListComponent
   */
  printReport(appointmentId) {
    let reqPayload = {
      transactionId: appointmentId,
      type: OPD_REPORT_TYPE.pdf,
      reportName: OPD_REPORT_NAME.appointment_Slip,
      isReports: false,
    };
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }

  /**
   *Add remarks
   *
   * @param {*} element
   * @memberof PatientAppointmentListComponent
   */
  addRemarks(element) {
    this.previousInternalRemarks = element.previousRemarks;
    const dialogRef = this.dialog.open(AppointmentRemarksDialogComponent, {
      height: "350px",
      width: "1000px",
      data: {
        listRemarks: this.previousInternalRemarks,
        name: OPD_CONST.appointmentListStatic.appointmentList,
        appointmentId: element.app.id,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.refreshSearch();
    });
  }

  /**
   *Show Reason Comments
   *
   * @param {*} element
   * @memberof PatientAppointmentListComponent
   */
  openReasonComments(element) {
    const dialogRef = this.dialog.open(
      AppointmentReasonreamrksDialogComponent,
      {
        height: OPD_CONST.appointmentListStatic.height,
        width: OPD_CONST.appointmentListStatic.width,
        data: {
          reason: element.rescheduleReason,
          remarks: element.rescheduleRemarks ? element.rescheduleRemarks : element.cancelRemarks,
        },
      }
    );

  }

  selectAll(e) {
    if (e.checked) {
      this.appointmentList.forEach((element) => {
        if (e.appointmentNo == element.appointmentNo)
          element.apptSelection = true;
      });
      if((this.appointmentList.filter((eachAppt) => eachAppt.apptSelection).length > 1)  &&  this.isAppointmentTimePast())
        this.isResschedule = false;
      else
        this.isResschedule = true;
      this.dataSource = new MatTableDataSource<any>(this.appointmentList);
    } else {
      this.appointmentList.forEach((element) => {
        element.apptSelection = false;
      });
      if ((this.appointmentList.filter((eachAppt) => eachAppt.apptSelection).length > 1)&&  this.isAppointmentTimePast())
        this.isResschedule = false;
      else
        this.isResschedule = true;
      this.dataSource = new MatTableDataSource<any>(this.appointmentList);
    }
  }

  selectCheckBox(e,data) {
    if (e.checked) {
      this.appointmentList.forEach((element) => {
        if (data.appNo == element.appNo)
          element.apptSelection = true;
      });
      if ((this.appointmentList.filter((eachAppt) => eachAppt.apptSelection).length > 1) ||  this.isAppointmentTimePast())
        this.isResschedule = false;
      else
        this.isResschedule = true;
      this.dataSource = new MatTableDataSource<any>(this.appointmentList);
    } else {
      this.appointmentList.forEach((element) => {
        if (data.appNo == element.appNo)
          element.apptSelection = false;
      });
      if( (this.appointmentList.filter((eachAppt) => eachAppt.apptSelection).length > 1) ||  this.isAppointmentTimePast())
        this.isResschedule = false;
      else
        this.isResschedule = true;
      this.dataSource = new MatTableDataSource<any>(this.appointmentList);
    }
  }
  isAppointmentTimePast(): boolean {
    const currentTime = Date.now() / 1000; // Assuming `appointmenttime` is in seconds
  
    for (let eachAppt of this.appointmentList) {
      if (eachAppt.apptSelection === true) {
        const appointmentTime = Number(this.epochConverter(eachAppt.appointmentDate));
        if (appointmentTime < currentTime) {
          return true;
        }
      }
    }
  
    return false;
  }
  isSelectedPatient(): boolean {
  
    for (let eachAppt of this.appointmentList) {
      if (eachAppt.apptSelection === true) {
          return true;
      }
    }
  
    return false;
  }
  /**
   *Cancel and Reschedule calling method
   *
   * @param {*} type
   * @memberof PatientAppointmentListComponent
   */
  cancelAppt(type) {
    if (this.isSelectedPatient()) {
    var ids: any[] = [];
    var currentTime = Number(new Date().getTime() / 1000);

    // this.appointmentList.forEach((eachAppt) => {
      if (this.isAppointmentTimePast()) {
        // if (appointmenttime < currentTime) {
          this.snackBar.open(
            this.langService.get("CommonAppoinment.validation"),
            this.langService.get("CommonAppoinment.Appointmentscannotbecanceled"),
            {
              duration: 3000,
            }
          );
        // } 
      }else {
        this.appointmentList.forEach((eachAppt) => {
          if (eachAppt.apptSelection == true) {
          if (type == OPD_CONST.appointmentListStatic.reschedule) {
            var patientInfo: any;
            if (eachAppt.app.patientType.code == OPD_CONST.appoinmentRef.temp) {
              patientInfo = {
                type: eachAppt.app.patientType.code,
                MRN: eachAppt.patientMrn,
                patientid: eachAppt.app.temporaryPatient.id,
                id: eachAppt.id,
                doctorCode: eachAppt.app.doctor ? eachAppt.app.doctor.code : "",
                departmentCode: eachAppt.app.specialty[0].coding[0].code,
                appointmentType: eachAppt.bookingTypeCode
                  ? eachAppt.bookingTypeCode
                  : "",
                remarks: eachAppt.comment,
                splReq: eachAppt.specialRequirements
                  ? eachAppt.specialRequirements
                  : null,
                  isReschedule:true,
                appointmentVisitType:eachAppt.appointmentType?eachAppt.appointmentType:"",
                appointmentVisitTypeCode:eachAppt.appointmentTypeCode?eachAppt.appointmentTypeCode:"",
                patientCategory:eachAppt.patientCategoryCode?eachAppt.patientCategoryCode:"",
                appointmentPriorityCode:eachAppt.appoinmentPriorityCode?eachAppt.appoinmentPriorityCode:"",
                appointmentPriority:eachAppt.appoinmentPriority?eachAppt.appoinmentPriority:"",
                specialInstruction:eachAppt.specialInstruction?eachAppt.specialInstruction:""
              };
              localStorage.setItem(
                OPD_CONST.appoinmentRef.aptResData,
                JSON.stringify(patientInfo)
              );
              this.router.navigate([OPD_API_URL.OPD_APPOINTMENT_NAVIGATE]);
            } else {
              patientInfo = {
                type: eachAppt.app.patientType.code,
                MRN: eachAppt.patientMrn,
                patientid: eachAppt.app.patient.id,
                id: eachAppt.id,
                doctorCode: eachAppt.app.doctor ? eachAppt.app.doctor.code : "",
                departmentCode: eachAppt.app.specialty[0].coding[0].code,
                appointmentType: eachAppt.bookingTypeCode
                  ? eachAppt.bookingTypeCode
                  : "",
                remarks: eachAppt.comment,
                splReq: eachAppt.specialRequirements
                  ? eachAppt.specialRequirements
                  : null,
                appointmentVisitType:eachAppt.appointmentType?eachAppt.appointmentType:"",
                appointmentVisitTypeCode:eachAppt.appointmentTypeCode?eachAppt.appointmentTypeCode:"",
                patientCategory:eachAppt.patientCategoryCode?eachAppt.patientCategoryCode:"",
                appointmentPriorityCode:eachAppt.appoinmentPriorityCode?eachAppt.appoinmentPriorityCode:"",
                appointmentPriority:eachAppt.appoinmentPriority?eachAppt.appoinmentPriority:"",
                specialInstruction:eachAppt.specialInstruction?eachAppt.specialInstruction:""
              };
              localStorage.setItem(
                OPD_CONST.appoinmentRef.aptResData,
                JSON.stringify(patientInfo)
              );
              this.router.navigate([OPD_API_URL.OPD_APPOINTMENT_NAVIGATE]);
            }
          } else {
            ids.push({ id: eachAppt.id });
          }
        }
        })
    }

    if (ids.length > 0) {
      const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
        width: "20%",
        data: { pageName:"PatientApointmentList",dialogName: type },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          let reqpaylad: any[] = []; // Initialize as an empty array  

      if (result.action === "yes") {  
        ids.forEach((element) => {  
          reqpaylad.push({ // Push each object to the array  
            id: element.id,  
            status: type=='cancel'?OPD_CONST.apppointmentListDisplay.cancelled:type=='NOSHOW'?OPD_CONST.apppointmentListDisplay.noShow:"",   
            remarks: result.remarks ? result.remarks : "",  
            reason: result.reason ? this.langService.createObjectList(result.reason[0]) : ""  
          });  
        });  
            this.subscriptionList.add(
              this.generalApiService
                .putTypeApi(
                  OPD_API_URL.OPD_SERVICE,
                  OPD_API_URL.OPD_APPOINTMENT_STATUS,
                  reqpaylad
                )
                .subscribe((response: any) => {
                  if (response) {
                    this.snackBar.open(
                      this.langService.get("CommonAppoinment.success"),
                      this.langService.get("AppointmentListPage.appointmenthasbeencancel"),
                      {
                        duration: 3000,
                      }
                    );
                  }
                  this.getAppointmentList();
                  this.getstatusCount();
                })

            );
          }
        })
      );
    }
  }else{
    this.snackBar.open(
      this.langService.get("CommonAppoinment.validation"),
      this.langService.get("CommonAppoinment.Pleaseselectanappointment"),
      { duration: 3000 }
    );
  }

  }

  /**
   *converter Method
   *
   * @param {*} strDate
   * @return {*}
   * @memberof PatientAppointmentListComponent
   */
  epochConverter(strDate) {
    if (strDate) {
      const datum = Date.parse(strDate);
      const epoch = datum / 1000;
      return epoch;
    } else return "";
  }

  /**
   *list next event
   *
   * @param {*} event
   * @memberof PatientAppointmentListComponent
   */
  getNext(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex ;
    this.offsetData = event.pageIndex * event.pageSize;
    if(this.selectedTabIndex==0){
      this.getAppointmentList();
    }else{
      this.getWaitingList();
    }
  }

  /**
   *Close method
   *
   * @memberof PatientAppointmentListComponent
   */
  ngOnDestroy() {
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
  }

  /**
   *getIndex method
   *
   * @param {number} index
   * @param {*} element
   * @memberof PatientAppointmentListComponent
   */
  getIndex(index: number, element: any) {
     this.selectedRow = index;
    this.selectedEncounter = element;
  }
  
  /**
   *Redirect to encounter and patient
   *
   * @param {*} _appData
   * @memberof PatientAppointmentListComponent
   */
  public Workflowmethod(_appData) {
    var appointmenttime = Number(this.epochConverter(_appData.appointmentDate));
    var currentTime = Number(new Date().getTime() / 1000);
    var checkInCutoffTime = appointmenttime + (this.AppointmentCheckInTime * 3600);

    if (currentTime > checkInCutoffTime && _appData.bookingTypeCode != OPD_CONST.aptref.apttTypeHscCode) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.validation"),
        this.langService.get("AppointmentListPage.appointmentcannotcheckintime"),
        {
          duration: 3000,
        }
      );
    }
    else if (_appData.endDate > currentTime && _appData.bookingTypeCode == OPD_CONST.aptref.apttTypeHscCode) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.validation"),
        this.langService.get("AppointmentListPage.appointmentcannotcheckintime"),
        {
          duration: 3000,
        }
      );
    }
    else {
      var patientInfo: any;
      if (_appData.app.patientType.code == OPD_CONST.appoinmentRef.temp) {
        patientInfo = {
          type: _appData.app.patientType.code,
          mrn: _appData.patientMrn,
          patientid: _appData.app.temporaryPatient.id,
          id: _appData.id,
          doctorCode: _appData.app.doctor ? _appData.app.doctor.code : "",
          departmentCode: _appData.app.specialty[0].coding[0].code,
          healthPackage: _appData.app.packageList ? _appData.app.packageList : [],
          bookingtype: _appData.bookingTypeCode,
          token:_appData.token,
          appointmentNo:_appData.appNo
        };
        localStorage.setItem(
          OPD_CONST.appoinmentRef.aptData,
          JSON.stringify(patientInfo)
        );
        this.router.navigate([OPD_API_URL.OPD_PATIENT_NAVIGATE]);
      } else {
        patientInfo = {
          type: _appData.app.patientType.code,
          mrn: _appData.patientMrn,
          patientid: _appData.app.patient.id,
          id: _appData.id,
          doctorCode: _appData.app.doctor ? _appData.app.doctor.code : "",
          departmentCode: _appData.app.specialty[0].coding[0].code,
          healthPackage: _appData.app.packageList ? _appData.app.packageList : [],
          bookingtype: _appData.bookingTypeCode,
          token:_appData.token,
          appointmentNo:_appData.appNo
        };
        localStorage.setItem(
          OPD_CONST.appoinmentRef.aptData,
          JSON.stringify(patientInfo)
        );
        this.router.navigate([OPD_API_URL.OPD_PATIENT_NAVIGATE]);
      }
    }
  }

  /**
   * Written for freeze column sticky solution
   *
   * @type {MatTable<any>}
   * @memberof PatientAppointmentListComponent
   */
  @ViewChild(MatTable) table: MatTable<any>;
  ngAfterViewInit() {
    this.subscriptionList.add(
      this.ngZone.onMicrotaskEmpty
        .pipe(take(3))
        .subscribe(() => this.table.updateStickyColumnStyles()));
  }

  getStatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: "",
      backgroundColor: "",
    };
    switch (status) {
      case "Booked":
        style.text = "Booked";
        style.backgroundColor = "#ffd88e";
        break;
      case "Arrived":
        style.text = "Arrived";
        style.backgroundColor = "#bef0bb";
        break;
      case "Cancelled":
        style.text = "Cancelled";
        style.backgroundColor = "#ffcdcd";
        break;
          case "Rescheduled":
          style.text = "Rescheduled";
          style.backgroundColor = "#649d9d";
          break;
        case "No Show":
          style.text = "No Show";
          style.backgroundColor = "#fdbd92";
          break;
        case "Payment Received":
          style.text = "Payment Received";
          style.backgroundColor = "#5f5fcb";
          break;
        case "Waiting":
          style.text = "WAITING";
          style.backgroundColor = "#f1c6a0";
          break;
        case "CANCELLED":
          style.text = "CANCELLED";
          style.backgroundColor = "#c86a6a";
          break;
        case "CONFIRMED":
         style.text = "CONFIRMED";
         style.backgroundColor = "#bef0bb";
         break;
      default:
        break;
    }
  
    return style;
  }
  
  refreshSearch() {
    this.searchAppt.fromDate = "";
    this.searchAppt.toDate = "";
    this.searchAppt.mrn = "";
    this.searchAppt.doctor = "";
    this.searchAppt.pname = "";
    this.searchAppt.dept = "";
    this.searchAppt.apptype = "";
    this.searchAppt.status = "";
    this.searchAppt.patientCategory = "";
    this.searchAppt.calledStatus="",
    this.searchAppt.priority="",
     this.offsetData = 0;
    this.pageSize = 10;
    if(this.selectedTabIndex==0){
      this.getAppointmentList();
      this.getstatusCount();
    }else{
      this.getWaitingList();
    }
  }
  addWaitingList(){ 
    const dialogRef = this.dialog.open(AddWaitingListDialogComponent, {
      width: "60%",
      data: {  },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        this.offsetData=0
        this.pageSize=10
        this.getWaitingList();
      }))

  }
  getWaitingList() {
    var fromDate = this.searchAppt.fromDate
      ? this.epochConverter(this.searchAppt.fromDate)
      : "";
    var toDate = this.searchAppt.toDate
      ? this.epochConverter(this.searchAppt.toDate)
      : "";
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(OPD_API_URL.OPD_SERVICE, `waitingAppointment/filter?fromDate=${fromDate}&toDate=${toDate}` +
            `&appointmentType=${this.searchAppt.apptype}&speciality=${this.searchAppt.dept}` +
            `&doctor=${this.searchAppt.doctor}&mrn=${this.searchAppt.mrn}` +
            `&offset=${this.offsetData}&size=${this.pageSize}&patientName=${this.searchAppt.pname}&businessStatus=${this.searchAppt.status}&consultationType=${this.searchAppt.consultationType}&calledStatus=${this.searchAppt.calledStatus}&priority=${this.searchAppt.priority}&patientCategory=${this.searchAppt.patientCategory}`)
        .subscribe((res:any) => {
          if (res ) {
            this.totalDataLength=res.totalRecords;
            res.response.forEach((element) => {
              element.serviceCategoryDisplay = element.serviceCategory ? element.serviceCategory.display : "";
              element.nameDisplay = element.patient?.name?.[0]?.text ?? element.temporaryPatient?.patientName ?? '';
                element.ageDisplay = element.patient?.birthDate || element.temporaryPatient?.birthDate 
                ? this.appoinmentService.calculateAge(element.patient?.birthDate || element.temporaryPatient?.birthDate) 
                : '';
                element.dobDisplay = element.patient?.birthDate ?? element.temporaryPatient?.birthDate ?? ''
                element.genderDisplay = 
                (element.patient?.gender?.display === 'FEMALE' || element.temporaryPatient?.gender?.display === 'FEMALE') 
                  ? 'F' 
                  : (element.patient?.gender?.display === 'MALE' || element.temporaryPatient?.gender?.display === 'MALE') 
                    ? 'M' 
                    : 'O';
               element.genderImage = element.genderDisplay === 'F' ? 'female-pink.png' : 'male-blue.png';
              element.specialityDisplay = element.specialty?.[0]?.coding?.[0]?.display || '';
              element.doctorDisplay = element.doctor?.display || '';
              element.datePreferanceDisplay = element.specificDateList ? this.datePreferanceDisplay(element.specificDateList) :
              element.expectedEndDateTime && element.expectedStartDateTime 
              ? `${new Date(element.expectedStartDateTime * 1000).toLocaleDateString('en-GB')} To ${new Date(element.expectedEndDateTime * 1000).toLocaleDateString('en-GB')}`
              : "";            
                element.contactDisplay = element.patient?.telecom?.[1]?.value ?? element.temporaryPatient?.mobileNumber ?? '',
                element.countryCodeDisplay = element.temporaryPatient?.countryCode?.display ?? element.patient?.countryCode ?? '',
                element.requestOnDesplay = element.createdDate ?? '';
                element.timeDesplay = element.createdDate ? this.formatRelativeTime(element.createdDate) : '';
            });
            this.waitingListDataSource = new MatTableDataSource<any>(res.response);
          }
        })
    );
  }
  datePreferanceDisplay(element) {
    if (!Array.isArray(element) || element.length === 0) {
      return ''; // Handle empty or invalid input gracefully
    }
  
    return element.map(date => {
      if (!isNaN(date)) {
        const specificDate = new Date(date * 1000);
        return `${specificDate.getDate().toString().padStart(2, '0')}/${
          (specificDate.getMonth() + 1).toString().padStart(2, '0')}/${specificDate.getFullYear()}`;
      }
      return '';
    }).join(', ');
  }
  
  onTabChange(){
    this.pageIndex=0;
    this.offsetData=0;
    this.pageSize = Configuration.PAGINATOR_DEFAULT;
    this.paginatorOptions = Configuration.PAGINATOR_OPTIONS;
    this.searchAppt = {
      fromDate: "",
      toDate: "",
      mrn: "",
      doctor: "",
      dept: "",
      consultationType: "",
      apptype: "",
      pname: "",
      status: "",
      priority: "",
      calledStatus: "",
      patientCategory: ""
    };
    if(this.selectedTabIndex==0){
    this.searchAppt.fromDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.searchAppt.toDate = new Date(new Date().setHours(23, 59, 0, 0));
    // this.searchList = this.appoinmentService.getappointmentSearchList(this);
    //      this.searchService.setSearch(this.searchList);
      this.getAppointmentList();
    }else{
      this.searchAppt.fromDate =null;
      this.searchAppt.toDate = null;
      // this.searchList = this.appoinmentService.getWaitingSearchList(this);
      //      this.searchService.setSearch(this.searchList);
    this.getWaitingList();
    }
  }
    public getSearchFilter() {
      this.subscriptionList.add(
        this.searchHead
          .getTypeSearch(OPD_API_URL.APPOINTMENT_LIST_SEARCH)
          .subscribe((data: any) => {
            this.searchList=this.searchHead.updateSearchHeader(data);
          })
      );
    }
  formatRelativeTime(timestamp: number): string {
    if (!timestamp) {
      return '';
    }
  
    return moment(timestamp * 1000).fromNow();
  }
  editWaitingList(element){
    if(element.businessStatus==OPD_CONST.apppointmentListDisplay.Waiting){
    const dialogRef=this.dialog.open(AddWaitingListDialogComponent, {
      width: "60%",
      data: { patient:element },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        this.offsetData=0
        this.pageSize=10
        this.getWaitingList();
      }))
  }
}
  confirmWaitingPatient(patient){
    if(patient.businessStatus==OPD_CONST.apppointmentListDisplay.Waiting){
    this.router.navigate([opdNavigation.OPD_APPOINTMENT_NAVIGATE], { state: { patient } });
    }else{
      this.snackBar.open("This patient is already confirm or cancelled","Error",{duration:2000});
    }
  }
  cancelWaitingPatient(patient){
    if(patient.businessStatus!==OPD_CONST.apppointmentListDisplay.CONFIRMED && patient.businessStatus !==OPD_CONST.apppointmentListDisplay.cancelled
    ){
    const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
      width: "20%",
      data: { pageName:"PatientApointmentList",dialogName: OPD_CONST.apppointmentListDisplay.cancel },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if(result.reason){
        let payload=[{
            id: patient.id,
            status: OPD_CONST.apppointmentListDisplay.cancelled,
            remarks:  result.remarks ? result.remarks : "",  
            reason: result.reason ? this.langService.createObjectList(result.reason[0]) : ""         
        }]
        this.subscriptionList.add(
          this.generalApiService
            .putTypeApi(OPD_API_URL.OPD_SERVICE, OPD_API_URL.CANCEL_WAITING_PATIENT,payload)
            .subscribe((res:any) => {
              this.snackBar.open("Patient Cancelled Successfully","Success",{duration:2000});
              this.offsetData=0
              this.pageSize=10
              this.pageIndex=0;
              this.getWaitingList()
            })
          )
        }
      })
    );
  }else{
    this.snackBar.open("Can not cancel","Error",{duration:2000});
  }
}
openContactDetails(element){
  let mobileNumber=element.patient?.telecom?.find(t => t.system === 'phone')?.value ?? element.temporaryPatient?.mobileNumber ?? '';
  let emailId=element.patient?.telecom?.find(t => t.system === 'email')?.value ?? element.temporaryPatient?.email ?? '';
  const dialogRef = this.dialog.open(AppointmentReasonreamrksDialogComponent, {
    width: "400px",
    data: { mobileNumber:mobileNumber,emailId:emailId , contactDisplay:true},
  });
}
  getPriorityClass(priority: string): string {
    if (!priority) return '';

    switch (priority) {
      case 'U':
        return 'dot-urgent';
      case 'H':
        return 'dot-high';
      case 'N':
        return 'dot-normal';
      case 'L':
        return 'dot-low';
      default:
        return '';
    }
  }
  openHistory(element: any) {
  this.dialog.open(AppoinmentPatientHistoryDialogComponentComponent, {
    width: '800px',
    data: {
      mrn: element.mrnNumber   
    }
  });
}
}
